import React from "react";
import { Nav, Sidenav, Dropdown, Icon } from "rsuite";
import "rsuite/dist/styles/rsuite-default.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCoffee,
  faStore,
  faCalendarDay,
  faBuilding,
  faRupeeSign,
  faLock,
  faFileContract,
} from "@fortawesome/free-solid-svg-icons";
import styles from "./leaseMenu.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
  withRouter,
  useParams,
} from "react-router-dom";
import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import apiUrl from "../apiUrlConstant";


const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class LeaseMenu extends React.Component {
  state = {
    openMenu: ["1"],
    disableOption: false,
    urlAppend: "",
    activeKey: "1-1",
    propsMenu: ",",
    'leaseStatus' : 0,
    'submitText' : "Submit Lease"
  };

  constructor(props) {
    super(props);
    //console.log(this.props.openMenu);
    this.state = {
      openMenu: [this.props.openMenu],
      disableOption: false,
      urlAppend: "",
      activeKey: "1-1",
      propsActiveKey: "1-1",
    };
  }

  componentDidMount() {
    if (this.props.match.params.id === undefined) {
      this.setState({
        disableOption: true,
      });
    } else {
      this.setState({
        disableOption: false,
        urlAppend: "/" + this.props.match.params.id,
      });
    }

    if (this.props.match.params.id !== undefined) {
      fetch(`${apiUrl.apiUrl.url}/create-lease/fetch-lease-status?id=` + this.props.match.params.id, {headers} )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            leaseStatus: data.status,
            'submitText' : "Submit Lease"
          });
          if(data.status != 0) {
            this.setState({
              'submitText' : "Approve Lease"
            });
          }

        })
        .catch((error) => {
          console.log(error);
        });
      console.log("okkk");
    }  
  }
  componentDidUpdate() {
    if (this.props.openMenu != this.state.propsMenu) {
      this.setState({
        propsMenu: this.props.openMenu,
        openMenu: [this.props.openMenu],
      });
    }
    if (this.props.activeKey != this.state.propsActiveKey) {
      this.setState({
        propsActiveKey: this.props.activeKey,
        activeKey: this.props.activeKey,
      });
    }
    if (this.props.match.params.id === undefined) {
      if (this.state.disableOption == false) {
        this.setState({
          disableOption: true,
        });
      }
    } else {
      if (this.state.disableOption == true) {
        this.setState({
          disableOption: false,
          urlAppend: "/" + this.props.match.params.id,
        });
      }
    }
  }

  render() {
    // let url = this.props.match;
    //console.log("rendering menu");
    return (
      <div className="leftSidebar">
        <Sidenav
          activeKey={this.state.activeKey}
          openKeys={this.state.openMenu}
          onOpenChange={(openKeys, event) => {
            console.log(openKeys[openKeys.length - 1]);
            this.setState({ openMenu: [openKeys[openKeys.length - 1]] });
          }}
        >
          <Sidenav.Body>
            <Nav>
              <Dropdown
                eventKey="1"
                //onClick={alert(1)}
                title="Parties, Unit & Brand Details"
                // icon={<FontAwesomeIcon icon={faStore} />}
              >
                <Dropdown.Item
                  eventKey="1-1"
                  componentClass={Link}
                  to={`/createlease/lease-landlord` + this.state.urlAppend}
                  onSelect={() => {
                    this.state.activeKey = "1-1";
                  }}
                >
                  Landlord & Unit Details
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="1-2"
                  componentClass={Link}
                  to={`/createlease/lease-occupier` + this.state.urlAppend}
                  disabled={this.state.disableOption}
                  onSelect={() => {
                    this.state.activeKey = "1-2";
                  }}
                >
                  Occupier & Brand Details
                </Dropdown.Item>
                
              </Dropdown>
              <Dropdown
                eventKey="2"
                title="Critical Dates"
                //onOpen={alert(1)}
                // icon={<FontAwesomeIcon icon={faCalendarDay} />}
              >
                <Dropdown.Item
                  eventKey="2-1"
                  componentClass={Link}
                  to={`/createlease/lease-term-details` + this.state.urlAppend}
                  disabled={this.state.disableOption}
                  onSelect={() => {
                    this.state.activeKey = "2-1";
                  }}
                >
                  Lease Term Details
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="2-2"
                  componentClass={Link}
                  to={
                    `/createlease/lock-in-notice-period` + this.state.urlAppend
                  }
                  disabled={this.state.disableOption}
                  onSelect={() => {
                    this.state.activeKey = "2-2";
                  }}
                >
                  Lock In & Notice Period
                </Dropdown.Item>
              </Dropdown>
              <Dropdown
                eventKey="3"
                title="Commercial Details"
                // icon={<FontAwesomeIcon icon={faBuilding} />}
              >
                <Dropdown.Item
                  eventKey="3-1"
                  componentClass={Link}
                  to={`/createlease/rental-details` + this.state.urlAppend}
                  disabled={this.state.disableOption}
                  onSelect={() => {
                    this.state.activeKey = "3-1";
                  }}
                >
                  Basic Rental Details
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="3-2"
                  componentClass={Link}
                  to={`/createlease/other-rental-details` + this.state.urlAppend}
                  disabled={this.state.disableOption}
                  onSelect={() => {
                    this.state.activeKey = "3-2";
                  }}
                >
                  Other Rental Details
                </Dropdown.Item>

                <Dropdown.Item
                  eventKey="3-3"
                  componentClass={Link}
                  to={`/createlease/cam-details` + this.state.urlAppend}
                  disabled={this.state.disableOption}
                  onSelect={() => {
                    this.state.activeKey = "3-3";
                  }}
                >
                  CAM Details
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="3-4"
                  componentClass={Link}
                  to={`/createlease/lease-broker-details` + this.state.urlAppend}
                  disabled={this.state.disableOption}
                  onSelect={() => {
                    this.state.activeKey = "3-4";
                  }}
                >
                  Broker Details
                </Dropdown.Item>
              </Dropdown>
              <Dropdown
                eventKey="4"
                title="Other Charges"
                // icon={<FontAwesomeIcon icon={faRupeeSign} />}
              >
                <Dropdown.Item
                  eventKey="4-1"
                  componentClass={Link}
                  to={`/createlease/utilities` + this.state.urlAppend}
                  disabled={this.state.disableOption}
                  onSelect={() => {
                    this.state.activeKey = "4-1";
                  }}
                >
                  Utilities
                </Dropdown.Item>

                <Dropdown.Item
                  eventKey="4-2"
                  componentClass={Link}
                  to={`/createlease/marketing-fund` + this.state.urlAppend}
                  disabled={this.state.disableOption}
                  onSelect={() => {
                    this.state.activeKey = "4-2";
                  }}
                >
                  Marketing Fund
                </Dropdown.Item>

                <Dropdown.Item
                  eventKey="4-3"
                  componentClass={Link}
                  to={
                    `/createlease/property-muncipal-tax-fund` +
                    this.state.urlAppend
                  }
                  disabled={this.state.disableOption}
                  onSelect={() => {
                    this.state.activeKey = "4-3";
                  }}
                >
                  Property & Muncipal Taxes
                </Dropdown.Item>

                <Dropdown.Item
                  eventKey="4-4"
                  componentClass={Link}
                  to={
                    `/createlease/parking-storage-signage` +
                    this.state.urlAppend
                  }
                  disabled={this.state.disableOption}
                  onSelect={() => {
                    this.state.activeKey = "4-4";
                  }}
                >
                  Parking , Storages & Signage
                </Dropdown.Item>
              </Dropdown>
              <Dropdown
                eventKey="5"
                title="Security Deposit Details"
                // icon={<FontAwesomeIcon icon={faLock} />}
              >
                <Dropdown.Item
                  eventKey="5-1"
                  componentClass={Link}
                  to={
                    `/createlease/rent-deposit-details` + this.state.urlAppend
                  }
                  disabled={this.state.disableOption}
                  onSelect={() => {
                    this.state.activeKey = "5-1";
                  }}
                >
                  Rent Deposit Details
                </Dropdown.Item>

                <Dropdown.Item
                  eventKey="5-2"
                  componentClass={Link}
                  to={`/createlease/cam-deposit-details` + this.state.urlAppend}
                  disabled={this.state.disableOption}
                  onSelect={() => {
                    this.state.activeKey = "5-2";
                  }}
                >
                  CAM Deposit Details
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="5-3"
                  componentClass={Link}
                  to={
                    `/createlease/other-deposit-details` + this.state.urlAppend
                  }
                  disabled={this.state.disableOption}
                  onSelect={() => {
                    this.state.activeKey = "5-3";
                  }}
                >
                  Other Deposit Details
                </Dropdown.Item>
              </Dropdown>
              <Dropdown
                eventKey="6"
                title="Lease Documents"
                // icon={<FontAwesomeIcon icon={faFileContract} />}
              >
                <Dropdown.Item
                  eventKey="6-1"
                  componentClass={Link}
                  to={`/createlease/upload-document` + this.state.urlAppend}
                  disabled={this.state.disableOption}
                  onSelect={() => {
                    this.state.activeKey = "6-1";
                  }}
                >
                  Upload Documents
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="6-2"
                  componentClass={Link}
                  to={`/createlease/commercial-clauses` + this.state.urlAppend}
                  disabled={this.state.disableOption}
                  onSelect={() => {
                    this.state.activeKey = "6-2";
                  }}
                >
                  Critical Clauses – Commercial
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="6-3"
                  componentClass={Link}
                  to={`/createlease/other-clauses` + this.state.urlAppend}
                  disabled={this.state.disableOption}
                  onSelect={() => {
                    this.state.activeKey = "6-3";
                  }}
                >
                  Critical Clauses – Other
                </Dropdown.Item>
              </Dropdown>

              <Dropdown
                eventKey="7"
                title="Landlord Charge Type"
              >
                <Dropdown.Item
                  eventKey="7-1"
                  componentClass={Link}
                  to={`/createlease/charge-rent` + this.state.urlAppend}
                  disabled={this.state.disableOption}
                  onSelect={() => {
                    this.state.activeKey = "7-1";
                  }}
                >
                  Charge Type
                </Dropdown.Item>
                
              </Dropdown>

              <Dropdown
                eventKey="8"
                title={this.state.submitText || "Submit Lease" }
                // icon={<FontAwesomeIcon icon={faEllipsisH} />}
              >
                <Dropdown.Item
                  eventKey="8-1"
                  componentClass={Link}
                  to={`/createlease/submit-lease` + this.state.urlAppend}
                  disabled={this.state.disableOption}
                  onSelect={() => {
                    this.state.activeKey = "8-1";
                  }}
                >
                  {this.state.submitText || "Submit Lease" }
                </Dropdown.Item>
              </Dropdown>
              {/* <Dropdown
                eventKey="7"
                title="Submit Lease"
                // icon={<FontAwesomeIcon icon={faEllipsisH} />}
              >
                <Dropdown.Item
                  eventKey="7-1"
                  disabled={this.state.disableOption}
                  onSelect={() => {
                    this.state.activeKey = "7-1";
                    this.props.history.push({
                      pathname:
                        `/createlease/submit-lease` + this.state.urlAppend,
                    });
                  }}
                >
                  Submit Lease
                </Dropdown.Item>
              </Dropdown> */}
            </Nav>
          </Sidenav.Body>
        </Sidenav>
      </div>
    );
  }
}

export default withRouter(LeaseMenu);
